import { JobDetails } from './../../domain/models/job-details';
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { JobsRepository } from '../../repositories';
import { Observable } from 'rxjs';
import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';

@Injectable({ providedIn: 'root' })
export class GetJobDetailsUsecase implements UseCase< BaseRequest<string>, JobDetails> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params:  BaseRequest<string>): Observable<JobDetails> {
    return this.jobRepository.getJobDetails(params);
  }

}
